import { contextInterface } from 'modelInterface/contextInterface';
import { INode } from '@ardoq/yfiles';
import {
  scenarioRelatedSelection$,
  toSelectedIds,
} from 'appContainer/MainAppModule/MainAppModuleSidebar/scenarioRelated/navigator/scenarioRelatedSelection$';
import type { ArdoqId } from '@ardoq/api-types';
import { hasContextAttributes, type GraphItem } from '@ardoq/graph';
import type { Node as OldGraphNode } from 'graph/types';
import type { Edge as OldGraphEdge } from 'graph/edge';
import { componentInterface } from '@ardoq/component-interface';

export const isContextGraphNode = (
  node: GraphItem | OldGraphNode | OldGraphEdge | undefined
) => {
  if (!node) {
    return false;
  }

  if (hasContextAttributes(node)) {
    return node.getIsContext();
  }

  const contextComponentId = contextInterface.getCurrentComponentId() ?? '';
  const isComponent = componentInterface.isComponent(contextComponentId);
  return isComponent && getModelId(node) === contextComponentId;
};

const getModelId = (node: GraphItem | OldGraphNode | OldGraphEdge) => {
  if ('modelId' in node) {
    return node.modelId;
  }
  if ('id' in node.dataModel) {
    return node.dataModel.id;
  }
  return null;
};

export const isContextNode = (node: INode) => isContextGraphNode(node.tag);

export const isSelectedRelatedNode = (node: INode) =>
  isPartOfMultiSelection(node?.tag?.modelId);

export const isPartOfMultiSelection = (modelId: ArdoqId) => {
  const selectedIds = toSelectedIds(scenarioRelatedSelection$.state.byId);
  return selectedIds.length > 1 && new Set(selectedIds).has(modelId);
};

const isImageGraphNode = (node: OldGraphNode | undefined) => {
  return Boolean(node?.getImage());
};

export const isImageNode = (node: INode) => isImageGraphNode(node.tag);
